import React, { Component, useState, useEffect, useRef } from 'react';
import { Table, Input, Form, FormGroup, Label, Button } from 'reactstrap';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

const TestConfig = (props) => {
    const [table, setTable] = useState([]);
    const [form, setForm] = useState([]);
    const [curr, setCurr] = useState();
    const [code, setCode] = useState();
    const [req, setReq] = useState();
    const dispatch = useDispatch()
    const selectRedux = state => state;
    const reduxData = useSelector(selectRedux);

    useEffect(() => {
        getTableData();
        getFormData();
    }, [])

    function getTableData() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk 
        }
        fetch('GetPraxisConfigTable', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTable(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    function getFormData() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk 
        }
        fetch('GetPraxisConfigForm', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setForm(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    function addNew(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        //console.log("reading form data: " + curr + ", " + code + ", " + req)
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            curr: curr,
            test: code,
            req: req
        }
        fetch('AddPraxisTest', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTable(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }    

    function changeReqScore(val, pk) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            pk: pk,
            newval: val 
        }
        fetch('UpdatePraxisTest', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTable(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    function deleteTest(pk) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        console.log("deleting: " + pk);
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            pk: pk 
        }
        fetch('DeletePraxisTest', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTable(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    return (<div>
        <Form inline className="d-flex" onSubmit={e => addNew(e) }>
            <FormGroup>
                <Label>Curriculum</Label>
                <Input type="select" name="curr" id="curr" defaultValue="DEFAULT" onChange={(e) => setCurr(e.target.value) }>
                    <option value="DEFAULT" disabled>Select...</option>
                    {form.map(item => (
                        <option value={item.code}>{item.code}  ({item.name})</option>
                    ))}
                </Input>
            </FormGroup>
            &nbsp;
            <FormGroup>
                <Label>Test Code</Label>
                <Input type="number" name="test" id="test" onChange={(e) => setCode(e.target.value)} /> 
            </FormGroup>
            &nbsp;
            <FormGroup>
                <Label>Required Score</Label>
                <Input type="number" name="score" id="score" onChange={(e) => setReq(e.target.value)} />
            </FormGroup>
            &nbsp;
            <Button type="submit" outline color="success">Add</Button>
        </Form>
        <Table>
            <thead>
                <tr>
                    <th>Curriculum Code</th>
                    <th>Curriculum Description</th>
                    <th>Test Code</th>
                    <th>Required Score</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {table.map(item => (
                    <tr>
                        <td>{item.currcode}</td>
                        <td>{item.currdescrip}</td>
                        <td>{item.testcode}</td>
                        <td><Input type="number" name="reqscore" id="reqscore" defaultValue={item.reqscore} onChange={(e) => changeReqScore(e.target.value, item.pk)} /></td>
                        <td><Button color="danger" outline onClick={e => deleteTest(item.pk)}>Delete</Button></td>
                    </tr>
                )) }
            </tbody>
        </Table>
    </div>)
}

export default TestConfig